"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileOptionsMenu = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('MobileOptionsMenu'), recompose_1.pure);
exports.MobileOptionsMenu = enhance(function (props) { return (React.createElement("div", { className: classNames('sok-mobile-options-menu', props.className) }, props.children)); });
//# sourceMappingURL=index.js.map